import styled from 'styled-components';
import RTKNews from '../../../assets/images/pluvaAutoLanding/RTK-GPS_news.jpg';
import RTKObject from '../../../assets/images/pluvaAutoLanding/RTK-GPS_object.jpg';
import Rocket from '../../../assets/images/pluvaAutoLanding/repair_emoji_rocket.png';
import Wireless from '../../../assets/images/pluvaAutoLanding/repair_emoji_wireless.png';
import Map from '../../../assets/images/pluvaAutoLanding/point_emoji_map.png';
import { Icon } from '../../../components/common/icon/Icon';
import { PointBadge } from './PointBadge';

interface IUniqueFeature {
  icon: string;
  featureName: string;
  description: string;
}

const uniqueFeatures: IUniqueFeature[] = [
  {
    icon: Wireless,
    featureName: '국내 1위 RTK MBC 채택',
    description: '압도적인 상용서비스 제공자!',
  },
  {
    icon: Map,
    featureName: '200개 이상 기준국 인프라',
    description: '20km 반경/ 방송통신망 동시 활용!',
  },
  {
    icon: Rocket,
    featureName: '3cm 이하 오차 정밀위치 제공',
    description: 'MBC RTK를 사용하는 순간부터!',
  },
];

const UniqueFeatureCard = ({ uniqueFeature }: { uniqueFeature: IUniqueFeature }) => {
  const { icon, featureName: serviceName, description } = uniqueFeature;
  return (
    <Card>
      <UniqueFeatureImageWrapper>
        <UniqueFeatureImage src={icon} alt={`${serviceName}의 아이콘`} />
      </UniqueFeatureImageWrapper>
      <ContentWrapper>
        <FeatureName>{serviceName}</FeatureName>
        <FeatureDescription>{description}</FeatureDescription>
      </ContentWrapper>
    </Card>
  );
};

export const RTKGPSSection = () => {
  return (
    <Container>
      <TitleSection>
        <PointBadge title={'유료 RTK-GPS'} />
        <Title>{'공중파 방송국 RTK 1위\n끊김없는 위성(GPS) 보장!'}</Title>
        <Image src={RTKObject} />
      </TitleSection>

      <RTKCheckListSection>
        <SectionGuideText>{'진짜 끊김 없으려면,\n반드시 아래 2가지를 확인하세요.'}</SectionGuideText>
        <RTKGPSCheckList>
          <RTKGPSCheckItemWrapper>
            <RTKGPSCheckItem>
              <Icon name={'CircleCheck'} width={20} height={20} fill={'#FF9500'} />
              <RTKGPSCheckItemContent>{'MBC RTK 등의 ‘유료 RTK’ 기지국을 제공하나요?'}</RTKGPSCheckItemContent>
            </RTKGPSCheckItem>
          </RTKGPSCheckItemWrapper>
          <RTKGPSCheckItemWrapper>
            <RTKGPSCheckItem>
              <Icon name={'CircleCheck'} width={20} height={20} fill={'#FF9500'} />
              <RTKGPSCheckItemContent>{'LG U+ 등의 ‘유료 통신망 유심’과 결합하였나요?'}</RTKGPSCheckItemContent>
            </RTKGPSCheckItem>
          </RTKGPSCheckItemWrapper>
        </RTKGPSCheckList>
      </RTKCheckListSection>

      <UniqueFeatureDescriptionSection>
        <SectionGuideText>
          {'혹시 무료 RTK 서비스를 제공하면서,\n높은 정밀도라고 홍보하는\n제품을 보고 계신건 아니시죠?'}
        </SectionGuideText>
        <UniqueSectionGuideTextHighlight>{'플루바 오토는 다릅니다!'}</UniqueSectionGuideTextHighlight>
      </UniqueFeatureDescriptionSection>

      <UniqueFeatureGroups>
        {uniqueFeatures.map((uniqueFeature) => {
          return <UniqueFeatureCard key={uniqueFeature.featureName} uniqueFeature={uniqueFeature} />;
        })}
        <SourceText>{'출처 : RTK.MBC.CO.KR - 방송국 MBC의 시스템'}</SourceText>
      </UniqueFeatureGroups>

      <RTKNewsSection>
        <RTKNewsDescription>
          <RTKNewsDescriptionBox>
            <RTKNewsTitleSection>
              <RTKNewsTitle>{'"오차범위 ㎝로"‥MBC\n차세대 위치 기술 미국 수출'}</RTKNewsTitle>
            </RTKNewsTitleSection>

            <RTKNewsImage src={RTKNews} />

            <RTKNewsContent>
              {/* eslint-disable-next-line quotes */}
              {`'RTK(알티케이) GPS 플랫폼'은 오차 범위를 센티미터급으로 낮춘 '위치 정보'를 방송통신망으로 제공하는 서비스로, 자동차뿐만 아니라 드론 택시, 로봇 배송 등에도 활용됩니다.`}
            </RTKNewsContent>
          </RTKNewsDescriptionBox>
        </RTKNewsDescription>
        <SourceText>{'출처 : MBC 뉴스 "오차범위 ㎝로"‥MBC 기술 미국 수출'}</SourceText>
      </RTKNewsSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Image = styled.img`
  width: 180px;
`;

const SectionGuideText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: pre-line;
`;

const RTKNewsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const RTKNewsDescription = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-black, #232429);
`;

const RTKNewsDescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const RTKNewsTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const RTKNewsTitle = styled.pre`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const RTKNewsContent = styled.p`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const RTKNewsImage = styled.img`
  width: 100%;
  border-radius: var(--radius-medium, 8px);
`;

const RTKCheckListSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const RTKGPSCheckList = styled.ul`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const RTKGPSCheckItemWrapper = styled.li`
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);

  &:last-child {
    border: none;
  }
`;

const RTKGPSCheckItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

const RTKGPSCheckItemContent = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;

const UniqueFeatureGroups = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Card = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) 24px;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  @media (max-width: 340px) {
    padding: var(--radius-large, 16px) 16px;
  }
`;

const UniqueFeatureImageWrapper = styled.div`
  display: flex;
  width: 48px;
  min-width: 48px;
  height: 48px;
  padding: var(--radius-medium, 8px);
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const UniqueFeatureImage = styled.img`
  width: 24px;
  height: 24px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`;

const FeatureName = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;

const FeatureDescription = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;

const UniqueFeatureDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const UniqueSectionGuideTextHighlight = styled.p`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const SourceText = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-align: center;

  /* Display/Small/s-light */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 15.6px */
`;
